import HTTP from "@/_helpers/http";
import { USERLOGINACTIVITY__API } from "@/_helpers/urls";
import { USERLOGINACTIVITY__MUTATIONS } from "../mutation-types";
import { USERLOGINACTIVITY__ACTIONS } from "../action-types";

// State
const state = {
  users: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [USERLOGINACTIVITY__MUTATIONS.USERLOGINACTIVITY](state, data) {
    state.users = data?.data?.activities
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [USERLOGINACTIVITY__ACTIONS.USERLOGINACTIVITY]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${USERLOGINACTIVITY__API.USERLOGINACTIVITY}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(USERLOGINACTIVITY__MUTATIONS.USERLOGINACTIVITY, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
